import InnerInput from "components/inputs/InnerInput/InnerInput";
import SwitchBtn from "components/buttons/SwitchBtn";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { ImageUpload } from "components/imageUpload";

interface PaymentProviderMainTabProps {
  payload: any;
  handleData: (
    key: string,
    value: string | boolean | number,
    img?: File | null,
  ) => void;

  fieldErrors?: Record<string, string>;
  clearFieldError: (field: string) => void;
  isReadOnly: boolean;
}
const ProvidersMainTab: FC<PaymentProviderMainTabProps> = ({
  payload,
  handleData,
  fieldErrors,
  clearFieldError,
  isReadOnly,
}) => {
  const { t } = useTranslation();
  const canEdit = !isReadOnly;

  return (
    <div className="bonus-form-content">
      <div className="bonus-form-box">
        <div className="bonus-form-box--item">
          <InnerInput
            value={payload?.title ?? ""}
            placeholder={t("enterTitle")}
            label={t("title")}
            type="text"
            id="loyalty-level-title"
            onChange={(e) => {
              handleData("title", e);
              clearFieldError("title");
            }}
            hasError={Boolean(fieldErrors?.["title"])}
            disabled={!canEdit}
          />
        </div>
        <div className="bonus-form-box--item">
          <InnerInput
            maxCodePoints={2500}
            value={payload?.description ?? ""}
            placeholder={t("enterText")}
            label={t("description")}
            type="textarea"
            id="loyalty-level-description"
            onChange={(e) => {
              handleData("description", e);
              clearFieldError("description");
            }}
            hasError={Boolean(fieldErrors?.["description"])}
            disabled={!canEdit}
          />
        </div>
      </div>
      <div className="bonus-form-box">
        <div className="game-form-img game-form-img--game center">
          <div
            className={classNames("game-item", {
              "has-error": fieldErrors?.["file"],
            })}
          >
            <ImageUpload
              image={payload?.image}
              size="large"
              onAddImage={(file) => {
                handleData("image", "", file);
                clearFieldError("file");
              }}
              isActive={payload?.isActive}
              disabled={!canEdit}
            />
          </div>
          <div className="game-form-switcher">
            <SwitchBtn
              activeTxt={t("active")}
              notActiveTxt={t("hidden")}
              isActive={!!payload?.isActive}
              handleClick={() => {
                handleData(
                  "isActive",
                  payload?.isActive ? !payload?.isActive : true,
                );
                clearFieldError("isActive");
              }}
              hasError={Boolean(fieldErrors?.["isActive"])}
              disabled={!canEdit}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProvidersMainTab;
